@let error = clusterAssignmentPlugin.selectors.error.asSignal();
@let isSubmitting = clusterAssignmentPlugin.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="narrow">
  <div class="atn-space-cluster-assignment-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-cluster-assignment-modal__content">
        <div class="atn-space-cluster-assignment-modal__field">
          <atn-ds-select-single-ec
            label="Cluster"
            descriptor="Space.Records.ClusterAssignment.ClusterSelect"
            [collection]="clustersEc"
            [group]="clusterAssignmentOptionsGroupId"
            [selectionTarget]="selectionTarget"
            [required]="isClusterRequiredSg()"
            [config]="{
              overlay: {
                entityName: 'Cluster',
                hasSearch: true,
              },
            }"
          />
        </div>

        @if (error) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="error.message"
          />
        }
      </div>

      <div
        class="atn-space-cluster-assignment-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!canSaveSg()"
          [loading]="isSubmitting"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
